module.exports = __webpack_public_path__ + "static/media/proximanova-regular.c11a7c5d.ttf";